import { Instance, Instances, useGLTF, useTexture } from '@react-three/drei';
import { useEffect, useMemo, useState } from 'react';
import * as THREE from 'three';

// Preload assets
useGLTF.preload('/env/pink.glb');
useTexture.preload('/env/pink.jpg');

export function Pink({ jsonFile }) {
  const { nodes } = useGLTF('/env/pink.glb', true, (error) => {
    console.error('Failed to load model', error);
  });
  // Load and configure the outdoor plant texture
  const outdoorPlantTexture = useTexture('/env/pink.jpg');
  outdoorPlantTexture.colorSpace = THREE.SRGBColorSpace;
  outdoorPlantTexture.flipY = false;
  outdoorPlantTexture.channel = 1;
  outdoorPlantTexture.generateMipmaps = false;

  // Reuse material across instances
  const material = useMemo(() => {
    return new THREE.MeshBasicMaterial({
      toneMapped: false,
      side: THREE.DoubleSide,
      map: outdoorPlantTexture,
    });
  }, [outdoorPlantTexture]);

  // State to store instance data
  const [data, setData] = useState([]);

  useEffect(() => {
    // Fetch JSON file
    fetch(jsonFile)
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then((jsonData) => {
        const parsedData = Object.values(jsonData).map((entry) => ({
          position: mapAxes(entry.position || [0, 0, 0]),
          scale: entry.scale || [1, 1, 1],
          rotation: mapRotation(entry.rotation || [0, 0, 0]),
        }));
        setData(parsedData);
      })
      .catch((error) => {
        console.error('Failed to load JSON data:', error);
      });
  }, [jsonFile]);

  if (!data.length) {
    return null; // Optional: Add a loading or fallback UI here
  }

  return (
    <Instances frustumCulled 
      range={data.length}
      geometry={nodes.main.geometry} // Shared geometry
      material={material} // Shared material
    >
      {data.map((props, index) => (
        <Instance key={index} position={props.position} scale={props.scale} rotation={props.rotation} />
      ))}
    </Instances>
  );
}

// Utility functions
function mapAxes([x, y, z]) {
  return [x, z, -y];
}

function mapRotation([rx, ry, rz]) {
  return [rx, rz, -ry];
}
